var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcpCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_628_80492)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_80492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1395 11C20.0246 11 18.8039 11.5511 17.5163 12.6382C16.9087 13.1489 16.3736 13.705 15.9834 14.1449C15.9834 14.1449 16.6077 14.7971 17.2933 15.4999C17.6668 15.0752 18.1963 14.4988 18.8151 13.9781C19.9578 13.0073 20.7047 12.8101 21.1339 12.8101C22.7393 12.8101 24.0436 14.0337 24.0436 15.5455C24.0436 17.0421 22.7393 18.2656 21.1339 18.2808C21.0559 18.2808 20.9667 18.2707 20.8552 18.2505C21.3234 18.4477 21.8307 18.5892 22.3045 18.5892C25.2476 18.5892 25.8273 16.7438 25.8608 16.6123C25.9444 16.2735 25.9945 15.9196 25.9945 15.5556C25.989 13.0427 23.8151 11 21.1395 11Z",
    fill: "url(#paint1_linear_628_80492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8551 20.091C11.9699 20.091 13.1906 19.5398 14.4783 18.4528C15.0858 17.9421 15.621 17.3859 16.0111 16.9461C16.0111 16.9461 15.3868 16.2938 14.7012 15.591C14.3278 16.0157 13.7982 16.5921 13.1795 17.1129C12.0368 18.0736 11.2843 18.2809 10.8606 18.2809C9.2553 18.2809 7.95095 17.0573 7.95095 15.5455C7.95095 14.0489 9.2553 12.8253 10.8606 12.8101C10.9387 12.8101 11.0279 12.8203 11.1394 12.8405C10.6711 12.6433 10.1639 12.5017 9.69008 12.5017C6.74693 12.4967 6.16722 14.3421 6.13378 14.4787C6.05017 14.8174 6 15.1714 6 15.5354C6 18.0483 8.17391 20.091 10.8551 20.091Z",
    fill: "url(#paint2_linear_628_80492)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0958 14.0185C12.7725 13.7354 11.2006 12.5775 9.69554 12.5371C7.00881 12.4764 6.22285 14.246 6.15039 14.4736C6.66879 12.4916 8.58629 11.0101 10.8605 11C12.7167 11 14.5952 12.6534 15.9832 14.1449L15.9887 14.1399C15.9887 14.1399 16.613 14.7921 17.2987 15.4949C17.2987 15.4949 18.079 16.3292 18.904 17.0623C19.2273 17.3454 20.7936 18.4881 22.2987 18.5286C25.0579 18.5994 25.8215 16.7286 25.8605 16.587C25.3533 18.5842 23.4302 20.0707 21.1448 20.0808C19.2886 20.0808 17.4101 18.4274 16.0166 16.9359C16.0166 16.9409 16.011 16.9409 16.011 16.946C16.011 16.946 15.3867 16.2938 14.7011 15.591C14.7067 15.591 13.9263 14.7516 13.0958 14.0185Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_80492",
    x1: 21,
    y1: -5,
    x2: 6,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_80492",
    x1: 18.53,
    y1: 11.7203,
    x2: 24.7287,
    y2: 18.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_80492",
    x1: 13.4663,
    y1: 19.3717,
    x2: 7.26758,
    y2: 12.4816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_80492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 9.09091,
    fill: "white",
    transform: "translate(6 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcpCoin);
export default __webpack_public_path__ + "static/media/icp-coin.92d6bd9344673c7604ca0c0d6f1e578e.svg";
export { ForwardRef as ReactComponent };